export default "__VITE_ASSET__XijAC$ec__"